enum FeedBackActionType {
	POST_FEEDBACK_REQUEST = "POST_FEEDBACK_REQUEST",
	POST_FEEDBACK_SUCCEEDED = "POST_FEEDBACK_SUCCEEDED",
	POST_FEEDBACK_FAILED = "POST_FEEDBACK_FAILED",
}

export default FeedBackActionType;
